
import { Component, Mixins } from 'vue-property-decorator';
import SettingsSelect from '@/features/settings/components/SettingsSelect.vue';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';

@Component({
  components: {
    Shipping: () => import('@/features/settings/components/preferences/content/Shipping.vue'),
    Customs: () => import('@/features/settings/components/preferences/content/Customs.vue'),
    Print: () => import('@/features/settings/components/preferences/content/Print.vue'),
    SchedulePickup: () => import('@/features/settings/components/preferences/content/SchedulePickup.vue'),
    Ecommerce: () => import('@/features/settings/components/preferences/content/Ecommerce.vue'),
    CarrierFilters: () => import('@/features/settings/components/preferences/content/CarrierFilters.vue'),
    UpdatesPreferences: () => import('@/features/settings/components/preferences/content/UpdatesPreferences.vue'),
    SettingsSelect,
  },
})
export default class Settings extends Mixins(ResponsivenessMixin) {
  private tabComponents = {
    shippingSettings: 'Shipping',
    customs: 'Customs',
    printSettings: 'Print',
    schedulePickup: 'SchedulePickup',
    ecommerce: 'Ecommerce',
    carrierFilters: 'CarrierFilters',
    updatesPreferences: 'UpdatesPreferences',
  }

  get routeQuery(): string {
    return this.$route.query.content as string;
  }
}
